
export enum ShoppingCartoccordionTabs {
  orderInfo = 0,
  BuyerContactInfo = 1,
  SellerContactInfo = 2,
  SalesRepInfo = 3,
  ShippingInfo = 4,
  BillingInfo = 5,
  orderDetail=6
}
